import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

const getAuthHeaders = () => {
    const token = getAccessToken();
    if (!token) {
        window.location.href = "/";
        return {};
    }

    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};

const periodParams = ({ periodFrom, periodTo }) => ({
    period_from: periodFrom,
    period_to: periodTo,
});

export const getSupplierDepositReport = async ({ periodFrom, periodTo }) => {
    const response = await axios.get(`${API_BASE_URL}/supplier-deposits/report`, {
        ...getAuthHeaders(),
        params: periodParams({ periodFrom, periodTo }),
    });
    return response.data;
};

export const getSupplierDepositGroups = async () => {
    const response = await axios.get(`${API_BASE_URL}/supplier-deposits/groups`, getAuthHeaders());
    return response.data || [];
};

export const createSupplierDepositGroup = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/supplier-deposits/groups`, payload, getAuthHeaders());
    return response.data;
};

export const updateSupplierDepositGroup = async (groupId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/supplier-deposits/groups/${groupId}`, payload, getAuthHeaders());
    return response.data;
};

export const deleteSupplierDepositGroup = async (groupId) => {
    const response = await axios.delete(`${API_BASE_URL}/supplier-deposits/groups/${groupId}`, getAuthHeaders());
    return response.data;
};

export const createSupplierDepositLink = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/supplier-deposits/links`, payload, getAuthHeaders());
    return response.data;
};

export const updateSupplierDepositLink = async (linkId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/supplier-deposits/links/${linkId}`, payload, getAuthHeaders());
    return response.data;
};

export const deleteSupplierDepositLink = async (linkId) => {
    const response = await axios.delete(`${API_BASE_URL}/supplier-deposits/links/${linkId}`, getAuthHeaders());
    return response.data;
};

export const upsertSupplierDepositCheckpoint = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/supplier-deposits/checkpoints`, payload, getAuthHeaders());
    return response.data;
};

export const deleteSupplierDepositCheckpoint = async (checkpointId) => {
    const response = await axios.delete(`${API_BASE_URL}/supplier-deposits/checkpoints/${checkpointId}`, getAuthHeaders());
    return response.data;
};
